// @file encapsulates opening the post action menu + setting the anchor for position the resulting popover
import { createDomElement } from '@@/native_bridge/ui'
import { useSurfacePostActionStore } from '@@/pinia/surface_post_action'
import type { Post } from '@@/types'

interface PostActionMenuTrigger {
  showPostActionMenuWithTriggerRect: (buttonEl: HTMLElement | null, post: Post) => void
}

export function usePostActionMenuTrigger(): PostActionMenuTrigger {
  const surfacePostActionStore = useSurfacePostActionStore()
  const { showPostActionMenu, setPostActionMenuTriggerRect } = surfacePostActionStore

  function showPostActionMenuWithTriggerRect(buttonEl: HTMLElement | null | undefined, post: Post): void {
    if (buttonEl == null) return

    // Trigger rect is calculated for mobile app to render post action menu at the correct position.
    // ASSUMPTION: buttonEl is a button element with centered content! See SurfacePostMoreActions.vue for example.
    // https://github.com/padlet/mozart/pull/23494
    const buttonRect = createDomElement(buttonEl)
    const buttonContentRect = createDomElement(buttonEl.firstElementChild as HTMLElement)

    const buttonContentCenter = {
      x: buttonContentRect.x + buttonContentRect.width / 2,
      y: buttonContentRect.y + buttonContentRect.height / 2,
    }

    const topOffset = buttonContentCenter.y - buttonRect.y

    // Calculate trigger rect based on button content center and offset
    const minX = buttonContentCenter.x - topOffset
    const minY = buttonRect.y
    const maxX = buttonContentCenter.x + topOffset
    const maxY = buttonContentCenter.y + topOffset
    const triggerRect = new DOMRect(minX, minY, maxX - minX, maxY - minY)

    setPostActionMenuTriggerRect({ postActionMenuTriggerRect: triggerRect })
    showPostActionMenu({ postCid: post.cid })
  }

  return {
    showPostActionMenuWithTriggerRect,
  }
}
